import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'endpointStatus'
})
export class EndpointStatusPipe implements PipeTransform {

  /**
   * Takes all statuses of an endpoint, sorts in order of importance (low to high) and returns the message assigned to the lowest number
   * @param obj 
   */
  transform(obj: any): string {
    let keysInOrder = Object.keys(obj).sort()
    return obj[keysInOrder[0]]
  }

}
